import clsx from 'clsx'
import React, { FC } from 'react'

import s from './styles.module.scss'

import { houseSearchTransportDurations } from '../house-search-travel-time.constant'
import { TransportTimeRange } from '../../../../../lib/graphql'

interface IHouseSearchTransportDurationProps {
  onClick: (value: TransportTimeRange) => void
  selectedValue?: TransportTimeRange
  disabled: boolean
}

export const HouseSearchTransportDuration: FC<
  IHouseSearchTransportDurationProps
> = ({ onClick, selectedValue, disabled }) => {
  return (
    <div className={clsx(s.grid, { [s.disabled]: disabled })}>
      {houseSearchTransportDurations.map((duration, index) => (
        <div
          key={`house-search-transport-duration-item-${index}`}
          className={clsx(s.gridItem, {
            [s.selected]: selectedValue === duration.value && !disabled,
          })}
          onClick={() => onClick(duration.value)}
        >
          <span>{duration.label}</span>
        </div>
      ))}
    </div>
  )
}
